import queryString from 'query-string';

// Utility functions

/**
 * @param {number} ms The number of milliseconds to delay
 * @return {object} A promise that simply resolves via a setTimeout
 */
export const delay = ms => new Promise(resolve => setTimeout(() => resolve(true), ms));

/**
 * Get Query Param By Name
 * Gets the value of passed in query param key
 * If no key or no value for key returns null
 * @param {string} name The name of the query param key
 * @param {string} path The path of query params to parse (defaults to window.location.search)
 * @return {string|null} - query param value
 */
export function getParameterByName(name, path = window.location.search) {
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    const results = regex.exec(path);

    if (!results || !results[2]) {
        return null;
    }

    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function reloadPage() {
    window.location.reload();
}

export function updateLocationWithNewQueryStrings(newParams = {}) {
    const existingParams = queryString.parse(window.location.search);
    const newQueryParams = queryString.stringify(Object.assign({}, existingParams, newParams));
    window.location.search = newQueryParams;
    return newQueryParams;
}
